<template>
  <div class="container">
  <div class="quyu">
    <div class="home-banner">
        <img class="banner-bg" src="@/assets/shuzihuaguanli.png" alt="">
        <div class="textBox typeArea">
        <p class="centerBanner animated zoomIn">对项目与人员的全面数字化管理</p>
        </div>
    </div>
    <div class="project">
      <div class="proj-box">
        <div class="proj-cont">
          <div style="padding-bottom: 45px;"></div>
          <div class="common-title">
            场景说明 
          </div>
          <div class="proj-text">
            <p>对例如从事地理测绘等的项目型公司，要在不同的地域同时开展不同类型、规模和承包形式的项目，涉及繁杂的流程管理以及对人财物的调度。为此，数字化管理与决策是保证全面把握各类业绩指标实现状况的关键性措施。</p>
          </div>
          <div style="padding-bottom: 55px;"></div>
        </div>
      </div>
      <div class="proj-box" style="background:#F3F4F7">
        <div class="proj-cont">
          <div style="padding-bottom: 80px;"></div>
          <div class="common-title">
            业务需求点 
          </div>
          <div style="padding-bottom: 80px;"></div>
          <div class="proj-t">
            <div class="proj-sanjiao">
              <img src="@/assets/sanjiao.png" alt="">
            </div>
            <div class="proj-text" style="font-size: 14px;">
              建立对业务的全流程数字化管理报告和业务看板系统
            </div>
          </div>
          <div class="proj-t">
            <div class="proj-sanjiao">
              <img src="@/assets/sanjiao.png" alt="">
            </div>
            <div class="proj-text" style="font-size: 14px;">
              建立预测系统，对未来产值进行预测，并根据未来产值目标对营销规模进行规划性预测
            </div>
          </div>
          <div style="padding-bottom: 50px;"></div>
        </div>
      </div>
    </div>
    <div class="proj-box">
      <div class="proj-cont">
        <div style="padding-bottom: 60px;"></div>
        <div class="common-title">
          解决方案 
        </div>
        <div class="proj-text" style="text-indent: 0;">
          <p>使用部盾的分析平台和报告及看板生成系统，在和企业数据对接后，生成四类用户端产出</p>
        </div>
        <div class="box-list">
          <ul>
            <li>
              <div class="active-box">
                <div class="li-img"><img src="@/assets/baogoa.png" alt=""></div>
                <div class="li-title">分级诊断报告</div>
                <div class="li-text">
                  <p>针对总公司和分公司的需求建立分级报告</p>
                  <p>按照售前、进行中项目和完成项目设计相应的业绩指标体系并进行诊断分析</p>
                  <p>按照业绩跟踪和评判指标体系，进行历史分析、变动因素分析、综合评价、业绩表现排序、潜力和问题点预警提示</p>
                </div>
              </div>
            </li>
            <li class="li-active">
              <div class="active-box">
                <div class="li-img"><img src="@/assets/kanban.png" alt=""></div>
                <div class="li-title">分级业务看板体系</div>
                <div class="li-text">
                  <p>面向业务管理和操作层面，针对不同的职责分别提供相应的看板模组 </p>
                </div>
              </div>
            </li>
            <li>
              <div class="active-box">
                <div class="li-img"><img src="@/assets/mokuai.png" alt=""></div>
                <div class="li-title">预测模块</div>
                <div class="li-text">
                  <p>根据新增合同和进行中项目的种类、数量、规模和产出周期，对未来产值和营收进行预测</p>
                  <p>根据未来产值目标，对营销规模进行规划性预测（反向预测）</p>
                </div>
              </div>
            </li>
            
          </ul>
          <div style="padding-bottom: 80px;"></div>
        </div>
        <div style="clear: both;"></div>
      </div>
    </div>
    <div class="proj-box">
      <div class="proj-cont">
        <div style="padding-bottom: 40px;"></div>
        <div class="common-title">
          全面的数字化业务表现跟踪平台 
        </div>
        <div class="proj-text">
          <p>为满足业务管理中对决策信息的随机需要，提供灵活的查询和报告的能力，涵盖全部业绩变量和指标的历史轨迹和现状</p>
          <p>可按照九个维度进行单维度和任意组合维度的分析，并提供数据和图表输出</p>
          <p>数据从现有数据库中直接提取并在标准化后生成数据集，用户端报告和看板产品使用企业现有BI系统的权限管理和推送功能完成</p>
        </div>
        <div class="proj-fangan">
          <img src="@/assets/组5-1.png" style="width: 1200px;height;588px;" alt="">
        </div>
        <div style="padding-bottom: 40px;"></div>
      </div>
    </div>
  </div>  
</div>
</template>

<script>
export default {
  name: "xiangmu",
  data() {
    return {
    };
  },
  methods: {
      
  },
  mounted() {

  },
}
</script>

<style scoped>
   
</style>